module.exports = __webpack_public_path__ + "static/img/Siku tembereng 30-50.b2fb092.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Siku tembereng 30-50.jpg
// module id = 99
// module chunks = 1